import { cva } from 'class-variance-authority';
import { ForwardedRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { ButtonBaseProps } from '../helpers/button.types';
import { ButtonCompoundVariants } from '../helpers/buttons.constants';

const buttonsVariants = cva(
    [
        'flex items-center justify-center gap-2',
        'font-semibold px-4',
        'whitespace-nowrap',
        'shadow-[0px_2px_4px_rgba(0,0,0,0.12),0px_2px_8px_rgba(0,0,0,0.1)] dark:shadow-[0px_0px_0px_rgba(0,0,0,0.0),0px_0px_0px_rgba(0,0,0,0.0)]',
        'cursor-pointer',
    ],
    {
        variants: {
            color: {
                primary: [],
                secondary: [],
                success: [],
                danger: [],
                warning: [],
            },
            variant: {
                default: [],
                shaded: ['shadow-none'],
            },
            size: {
                xs: ['text-xs h-8 rounded-lg'],
                sm: ['text-sm h-9 rounded-[10px]'],
                normal: ['text-sm h-10 rounded-[10px]'],
                lg: ['text-base h-11 rounded-xl'],
            },
        },
        compoundVariants: ButtonCompoundVariants,
        defaultVariants: {
            color: 'primary',
            variant: 'default',
            size: 'normal',
        },
    }
);

export interface ButtonProps extends ButtonBaseProps<typeof buttonsVariants> {
    ref?: ForwardedRef<HTMLButtonElement>;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { children, variant, color, size, className, ...rest } = props;

    return (
        <button ref={ref} {...rest} className={twMerge(buttonsVariants({ color, variant, size, className }))}>
            {children}
        </button>
    );
});

export default Button;
